import React, { useEffect, useState } from 'react';
import './AddressList.css';
import Header from '../common/Header';
import { Link } from 'react-router-dom';
import httpService from "../../services/HttpService";

const AddressList = () => {
    const [addresses, setAddresses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Fetch addresses from the API using httpService
        const fetchAddresses = async () => {
            try {
                const data = await httpService.get('/address').then(response => response.json()); // Use httpService.get
                setAddresses(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchAddresses();
    }, []);

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this address?')) {
            return; // User canceled deletion
        }

        try {
            await httpService.delete(`/api/address/${id}`); // Use httpService.delete

            // Remove the deleted address from state
            setAddresses((prevAddresses) =>
                prevAddresses.filter((address) => address.id !== id)
            );

            console.log(`Address with ID ${id} deleted successfully.`);
        } catch (err) {
            console.error(err.message);
        }
    };

    // if (loading) return <p>Loading...</p>;
    if (loading) return <p></p>;
    if (error) return <p>Error: {error}</p>;

    return (
        <>
            <Header />
            <main className="ua-page">
                <Link to={`/address-new`} className="link">
                    <div className="ua-address-container">
                        <p className="ua-address-string">Добавить адрес</p>
                        <i className="material-symbols-sharp ua-delete-icon">add_home_work</i>
                    </div>
                </Link>

                {addresses.map((address) => (
                    <div
                        className="ua-address-container"
                        key={address.id}
                    >
                        <Link to={`/address-single/${address.id}`} className="link">
                            <p className="ua-address-string">
                                {address.city.name}, {address.street}, {address.house}
                            </p>
                        </Link>
                        <i
                            className="material-symbols-sharp ua-delete-icon"
                            onClick={() => handleDelete(address.id)} // Add click handler
                        >
                            delete
                        </i>
                    </div>
                ))}
            </main>
        </>
    );
};

export default AddressList;